import { useContext } from 'react';

import { SidePanelsContext } from './context';

export const useOpenSideNavigation = (): [boolean, () => void] => {
  const { sideNavigationOpen, toggleSideNavigation } =
    useContext(SidePanelsContext);

  return [sideNavigationOpen, toggleSideNavigation];
};
